// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Feed: Opt-in, nur Aggregate, ausschließlich unter Götter-Alias — nie echte Namen.
// Online-only (ponytail: Feed-Offline-Cache erst, wenn ihn jemand vermisst).
import { pb } from "./pb"

export interface FeedPost {
  id: string
  owner: string
  alias: string
  date: string
  day_code: string
  exercises_count: number
  volume_kg: number
  duration_min: number
}

export interface Reaction {
  id: string
  post: string
  user: string
  emoji: "💪" | "🔥" | "👏"
}

function me() {
  return pb.authStore.record
}

/** Teilt der/die Angemeldete den Feed? (Opt-in + Alias gesetzt) */
export function sharingEnabled(): boolean {
  const u = me()
  return Boolean(u?.share_feed && String(u?.feed_alias ?? "").trim())
}

/** Nach Trainingsabschluss rufen: legt den Feed-Beitrag an — still, wenn nicht geteilt wird. */
export async function publishWorkout(p: {
  date: string
  day_code: string
  exercises_count: number
  volume_kg: number
  duration_min: number
}): Promise<void> {
  const u = me()
  if (!u || !sharingEnabled()) return
  try {
    await pb.collection("feed_posts").create({
      owner: u.id,
      alias: String(u.feed_alias).trim(),
      ...p,
      volume_kg: Math.round(p.volume_kg),
    })
  } catch {
    // Feed ist Bonus — ein Fehler hier darf den Trainingsabschluss nie stören.
  }
}

/** Neueste Beiträge inkl. Reaktionen (eine Abfrage je Collection, clientseitig gejoint). */
export async function loadFeed(limit = 30): Promise<Array<FeedPost & { reactions: Reaction[] }>> {
  // ponytail: nur nach Datum sortiert — feed_posts hat kein autodate-Feld (PB 0.23)
  const posts = await pb.collection("feed_posts").getList<FeedPost>(1, limit, { sort: "-date" })
  const ids = posts.items.map((p) => p.id)
  let reactions: Reaction[] = []
  if (ids.length) {
    reactions = await pb.collection("reactions").getFullList<Reaction>({
      filter: ids.map((id) => `post = "${id}"`).join(" || "),
    })
  }
  return posts.items.map((p) => ({ ...p, reactions: reactions.filter((r) => r.post === p.id) }))
}

/** Eigene Reaktion setzen/wechseln; gleiche nochmal = entfernen. */
export async function toggleReaction(postId: string, emoji: Reaction["emoji"]): Promise<void> {
  const uid = me()?.id
  if (!uid) return
  const mine = (await pb.collection("reactions").getList<Reaction>(1, 1, {
    filter: `post = "${postId}" && user = "${uid}"`,
  })).items[0]
  if (!mine) {
    await pb.collection("reactions").create({ post: postId, user: uid, emoji })
  } else if (mine.emoji === emoji) {
    await pb.collection("reactions").delete(mine.id)
  } else {
    await pb.collection("reactions").update(mine.id, { emoji })
  }
}
